import React, { useState, useEffect } from 'react';
import { Award } from 'lucide-react';

const CertificateDisplay: React.FC = () => {
  const [showCertificate, setShowCertificate] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowCertificate(true)}
        className="fixed right-4 top-1/2 -translate-y-1/2 z-50 p-3 rounded-full bg-primary text-primary-foreground shadow-lg transition-all duration-300 hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        aria-label="View Certificate"
      >
        <Award className="w-6 h-6" />
      </button>

      {showCertificate && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowCertificate(false)}
        >
          <div 
            className="relative max-w-3xl w-full mx-4 animate-fade-in"
            onClick={e => e.stopPropagation()}
          >
            <div className="relative rounded-lg overflow-hidden">
              <div className="absolute inset-0 animate-border rounded-lg">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />
              </div>
              <div className="relative bg-card m-[3px] rounded-lg p-4">
{/* This section is update for Certificate image display */}
                <img
                  src="https://marketstream.in/img/Certificate/dpiit.png"
                  alt="DPIIT Certificate"
                  className="w-full h-auto rounded"
                />
              </div>
            </div>
            <button
              onClick={() => setShowCertificate(false)}
              className="absolute -top-4 -right-4 p-2 rounded-full bg-primary text-primary-foreground"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CertificateDisplay;